const data = {
  pageName: "MyAccount",
  servicesBaseUrl: "/api/",
  myAccountLegacyBaseUrl: "/api/",

  roojoom: {
    maxRetries: 30,
    interval: 1000,
    delay: 4
  },

  csrfToken: "ce0e81e9af0cc3ad48721b98943bc3f09c156b10590e6ad5c2d5b7b03e33f515",

  services: {
    translations: {
      url: "MyAccount/translations",
      params: {}
    },
    heroBanner: {
      url: "MyAccount/heroBanner",
      params: {}
    },
    accountsList: {
      url: "MyAccount/accountsList",
      params: {}
    },
    paymentsHistory: {
      url: "MyAccount/paymentsHistory",
      params: {}
    },
    billsHistory: {
      url: "MyAccount/billsHistory",
      params: {}
    },
    cardBalance: {
      url: "MyAccount/cardBalance",
      params: {}
    },
    gdprAssetSettings: {
      url: "gdpr/assetSettings",
      params: {}
    },
    afmLevel: {
      url: "MyAccount/Dashboard/afmLevel",
      params: {}
    },
    baLevel: {
      url: "MyAccount/Dashboard/baLevel",
      params: {}
    },
    connectionLevel: {
      url: "MyAccount/Dashboard/connectionLevel",
      params: {}
    },
    connectionUsage: {
      url: "MyAccount/Dashboard/connectionUsage",
      params: {}
    },
    prepayUsageReport: {
      url: "MyAccount/Dashboard/usageReport",
      params: {}
    },
    assetInfo: {
      url: "MyAccount/Dashboard/assetInfo",
      params: {}
    },
    eligibleBundles: {
      url: "MyAccount/BundleActivation/eligibleBundles",
      params: {}
    },
    productOrdering: {
      url: "MyAccount/BundleActivation/productOrdering",
      params: {}
    },
    productOrderingAndValidation: {
      url: "MyAccount/BundleActivation/productOrderingAndValidation",
      params: {}
    },
    billDetails: {
      url: "MyAccount/Billing/billDetails",
      params: {}
    },
    billCycles: {
      url: "MyAccount/Billing/billCycles",
      params: {}
    },
    productsServices: {
      url: "MyAccount/ProductsServices/productsServices",
      params: {}
    },
    productsBundles: {
      url: "MyAccount/ProductsServices/productsBundles",
      params: {}
    },
    callAnalysis: {
      url: "MyAccount/CallAnalysis/callAnalysis",
      params: {}
    },
    requestPuk: {
      url: "MyAccount/PukRetrieval/requestPuk",
      params: {}
    },
    subscriptionHistory: {
      url: "MyAccount/TvPaymentHistory/subscriptionHistory",
      params: {}
    },
    getSubscriptionHistoryPdf: {
      url: "MyAccount/TvPaymentHistory/getSubscriptionHistoryPdf",
      params: {}
    },
    tvDevices: {
      url: "MyAccount/TvDevices/getDevices",
      params: {}
    },
    deleteDevice: {
      url: "MyAccount/TvDevices/deleteDevice",
      params: {}
    },
    getPersonalDetails: {
      url: "MyAccount/TvSettings/getPersonalDetails",
      params: {}
    },
    getSubscriptionDetails: {
      url: "MyAccount/TvSettings/getSubscriptionDetails",
      params: {}
    },
    changeName: {
      url: "MyAccount/TvSettings/changeName",
      params: {}
    },
    changeNameLastName: {
      url: "MyAccount/TvSettings/changeNameLastName",
      params: {}
    },
    changeMsisdn: {
      url: "MyAccount/TvSettings/changeMsisdn",
      params: {}
    },
    ottDeleteAccount: {
      url: "MyAccount/TvSettings/ottDeleteAccount",
      params: {}
    },
    changeEmail: {
      url: "MyAccount/TvSettings/changeEmail"
    },
    requestEmailValidation: {
      url: "MyAccount/TvSettings/requestEmailValidation",
      params: {}
    },
    getPaymentOptions: {
      url: "MyAccount/TvSettings/getPaymentOptions",
      params: {}
    },
    getPaymentMethod: {
      url: "MyAccount/TvSettings/getPaymentMethod",
      params: {}
    },
    deletePaymentMethod: {
      url: "MyAccount/TvSettings/deletePaymentMethod",
      params: {}
    },
    resumeSubscription: {
      url: "MyAccount/TvSettings/resumeSubscription",
      params: {}
    },
    cancelSubscription: {
      url: "MyAccount/TvSettings/cancelSubscription",
      params: {}
    },
    getWifiSettings: {
      url: "MyAccount/WifiSettings/getWifiSettings",
      params: {}
    },
    updateWifiSettings: {
      url: "MyAccount/WifiSettings/updateWifiSettings",
      params: {}
    },
    getPsms: {
      url: "MyAccount/Psms/getPsms",
      params: {}
    },
    updatePsms: {
      url: "MyAccount/Psms/updatePsms",
      params: {}
    },
    getBarrings: {
      url: "MyAccount/BarringCategories/getBarrings",
      params: {}
    },
    updateBarrings: {
      url: "MyAccount/BarringCategories/updateBarrings",
      params: {}
    },
    getPromisedSpeeds: {
      url: "MyAccount/NetNeutrality/getPromisedSpeeds",
      params: {}
    },
    openTicket: {
      url: "MyAccount/NetNeutrality/openTicket",
      params: {}
    },
    getRequestHistory: {
      url: "MyAccount/NetNeutrality/getRequestHistory",
      params: {}
    },
    getMeasuresPerTicket: {
      url: "MyAccount/NetNeutrality/getMeasuresPerTicket",
      params: {}
    },
    cancelTicket: {
      url: "MyAccount/NetNeutrality/cancelTicket",
      params: {}
    },
    getDirectDebit: {
      url: "MyAccount/DirectDebit/getDirectDebit",
      params: {}
    },
    removeDirectDebit: {
      url: "MyAccount/DirectDebit/removeDirectDebit",
      params: {}
    },
    getCustomerOffers: {
      url: "MyAccount/Convergence/getCustomerOffers",
      params: {}
    },
    getCurrentPlan: {
      url: "MyAccount/Convergence/getCurrentPlan",
      params: {}
    },
    getProductRecommendation: {
      url: "MyAccount/Convergence/getProductRecommendation",
      params: {}
    },
    createProductOrder: {
      url: "MyAccount/Convergence/createProductOrder",
      params: {}
    },
    createServiceRequest: {
      url: "MyAccount/TvOffer/createServiceRequest",
      params: {}
    },
    getInstallationAddress: {
      url: "MyAccount/TvOffer/getInstallationAddress",
      params: {}
    },
    getNewInstallationAddress: {
      url: "MyAccount/TvOffer/getNewInstallationAddress",
      params: {}
    },
    getJourneyConfig: {
      url: "MyAccount/Convergence/getJourneyConfig",
      params: {}
    },
    settingsData: {
      url: "settings/data",
      params: {}
    },
    settlementsEligibility: {
      url: "MyAccount/settlementsEligibility",
      params: {}
    },
    submitSettlement: {
      url: "MyAccount/submitSettlement",
      params: {}
    },
    getAskOnce: {
      url: "MyAccount/AskOnce/getAskOnce",
      params: {}
    },
    esimGetResource: {
      url: "MyAccount/Esim/esimGetResource",
      params: {}
    },
    esimCheckEligibility: {
      url: "MyAccount/Esim/esimCheckEligibility",
      params: {}
    },
    esimClearSession: {
      url: "MyAccount/Esim/esimClearSession",
      params: {}
    },
    noosCustomer: {
      url: "MyAccount/NeverOutOfService/noosCustomer",
      params: {}
    },
    noosTicketInformation: {
      url: "MyAccount/NeverOutOfService/noosTicketInformation",
      params: {}
    },
    noosActivateRezerva: {
      url: "MyAccount/Reserva/noosActivateRezerva",
      params: {}
    },
    noosActivateFCF: {
      url: "MyAccount/FreeCallForwarding/noosActivateFCF",
      params: {}
    },
    noosRemoveFCF: {
      url: "MyAccount/FreeCallForwarding/noosRemoveFCF",
      params: {}
    },
    getMajorIncidents: {
      url: "MyAccount/MajorIncidents/getMajorIncidents",
      params: {}
    },
    createMajorTroubleTicket: {
      url: "MyAccount/MajorIncidents/createMajorTroubleTicket",
      params: {}
    },
    sendMajorSms: {
      url: "MyAccount/MajorIncidents/sendSms",
      params: {}
    },
    cuOttEligibleBundles: {
      url: "MyAccount/CuOtt/getGenericAppConfigs",
      params: {}
    },
    roojoomTranslations: {
      url: "roojoom/translations",
      params: {}
    },
    roojoomCreateSession: {
      url: "roojoom/createSession",
      params: {}
    },
    roojoomGetInteraction: {
      url: "roojoom/getInteraction",
      params: {}
    },
    roojoomSendInteraction: {
      url: "roojoom/sendInteraction",
      params: {}
    }
  },
  externalLinks: {
    billPayment: "/forms/bill-payment",
    tobi: "https://www.vodafone.gr/epikoinonia/tobi/#chatopen",
    exitBeta: "/old-myaccount",
    askHelp: "/exypiretisi",
    gdpr: "/settings/gdpr",
    anonymousTopUp: "/ypostirixi/ananeosi-xronou-omilias",
    eBill: "/settings/ebill/",
    eBillFixedOldUrl: "https://myhomeaccount.vodafone.gr/Myhol/eBill.aspx",
    eBillMobileOldUrl:
      "https://www.vodafone.gr/portal/client/idm/loadUserProfile.action",
    wifiSettingsFaq:
      "https://www.vodafone.gr/giga-network/giga-home/giga-wifi/",
    settingsUrl: "/settings/"
  },
  externalContent: {
    Billing: {
      left: "",
      top: "",
      right: "/ext_files/test-pages/my-account-billing-side-content.html",
      bottom: "/ext_files/test-pages/my-account-tiles-content.html"
    },
    Dashboard: {
      left: "",
      top: "",
      right: "",
      bottom: "/ext_files/test-pages/my-account-tiles-content.html"
    },
    Prepay: {
      left: "",
      top: "",
      right: "",
      bottom: "/ext_files/test-pages/my-account-prepay-content.html"
    },
    VodafoneTv: {
      left: "/ext_files/test-pages/my-account-tv-side-content.html",
      top: "",
      right: "",
      bottom: "/ext_files/test-pages/my-account-tv-tiles-content.html"
    }
  },
  clickToCallForms: {
    ClickToCallFixed: {
      title: "Σε ενδιαφέρει η προσφορά;",
      subTitle:
        "Θα σε καλέσουμε στο παρακάτω αριθμό επικοινωνίας για να ολοκληρώσουμε την διαδικασία της ανανέωσης. Αν επιθυμείς να σε καλέσουμε σε άλλο αριθμό παρακαλούμε συμπλήρωσέ τον.",
      subtitleUnavailable1:
        "Eκτός ωρών λειτουργίας - Η υπηρεσία λειτουργεί <b>καθημερινές 09:00 - 21:00 & Σάββατο 09:00 - 17:00</b>.",
      subtitleUnavailable2:
        "Εναλλακτικά συμπλήρωσε την παρακάτω φόρμα επικοινωνίας και θα επικοινωνίσουμε μαζί σου το συντομότερο δυνατόν.",
      phone: "Τηλέφωνο",
      nameLabel: "Όνομα",
      surname: "Επώνυμο",
      comments: "Σχόλια",
      placeHolder: "πχ 69ΧΧ ΧΧΧ ΧΧΧ",
      placeHolderName: "πχ Γιάννης",
      placeHolderSurName: "πχ Παπαδόπουλος",
      id: 1490667548678,
      buttonText: "Καλέστε με",
      ok: "OK",
      success: "Σύντομα ένας εκπρόσωπος μας θα επικοινωνήσει μαζί σου.",
      clicktocallversion: "NEW",
      clicktocallcalendar: "cbu",
      bottomText:
        "Η υπηρεσία λειτουργεί καθημερινά 09:00 - 21:00 και Σάββατο  09:00 - 17:00.",
      fail: "Το αίτημά σου δεν καταχωρήθηκε",
      serverErrorMessage:
        "Η υπηρεσία δεν είναι διαθέσιμη. Παρακαλώ δοκιμάστε αργότερα.",
      checkClickToCallRequest:
        '{"url":"clickToCall/checkClickToCallRequest","params":{"type":""}}',
      clicktocallformphone: "302106702610",

      name: "ClickToCallFixed",
      checkClickToCallAvailability:
        '{"url":"clickToCall/checkClickToCallAvailability","params":{"type":""}}',
      clicktocallformid: "Sales",
      status: "ED",
      callinglist: "s_promo",
      description: "",

      subtype: "Click2CallDefinition"
    },
    ClickToCallFixedConvergence: {
      title: "Απόκτησέ το τώρα",
      subTitle:
        "Θα σε καλέσουμε στο παρακάτω αριθμό επικοινωνίας για να ολοκληρώσουμε την διαδικασία της ανανέωσης. Αν επιθυμείς να σε καλέσουμε σε άλλο αριθμό παρακαλούμε συμπλήρωσέ τον.",
      subtitleUnavailable1:
        "Συμπλήρωσε το νούμερό σου και θα σε καλέσουμε άμεσα",
      subtitleUnavailable2: "",
      phone: "Τηλέφωνο",
      nameLabel: "Όνομα",
      surname: "Επώνυμο",
      comments: "Σχόλια",
      placeHolder: "πχ 69ΧΧ ΧΧΧ ΧΧΧ",
      placeHolderName: "πχ Γιάννης",
      placeHolderSurName: "πχ Παπαδόπουλος",
      id: 1490667548678,
      buttonText: "Κάλεσέ με",
      ok: "OK",
      success: "Σύντομα ένας εκπρόσωπος μας θα επικοινωνήσει μαζί σου.",
      clicktocallversion: "NEW",
      clicktocallcalendar: "cbu",
      bottomText: "Η υπηρεσία λειτουγεί <span>καθημερινές 09:00 - 21:00</span>",
      fail: "Το αίτημά σου δεν καταχωρήθηκε",
      serverErrorMessage:
        "Η υπηρεσία δεν είναι διαθέσιμη. Παρακαλώ δοκιμάστε αργότερα.",
      checkClickToCallRequest:
        '{"url":"clickToCall/checkClickToCallRequest","params":{"type":""}}',
      clicktocallformphone: "302106702610",

      name: "ClickToCallFixed",
      checkClickToCallAvailability:
        '{"url":"clickToCall/checkClickToCallAvailability","params":{"type":""}}',
      clicktocallformid: "Sales",
      status: "ED",
      callinglist: "s_promo",
      description: "",

      subtype: "Click2CallDefinition"
    }
  },
  webTools: {
    title: "Τα εργαλεία μου",
    button: {
      text: "Όλα τα εργαλεία",
      url:
        "/my-vodafone/settings/?i_source=mvw-tile&i_medium=links&i_content=dashboard-asset&i_owner=dc-web&i_name=20220414-mvw-settings"
    },
    fixed: {
      links: [
        {
          key: "1490638544354",
          title: "Ρυθμίσεις WiFi",
          url: "/my-vodafone/wifi-settings",
          icon: "broadband-or-wifi-hi-dark",
          imageUrl: "/content/dynamic-tiles/broadband-or-wifi-hi-dark@2x.png"
        },
        {
          key: "1490639255842",
          title: "Διαχείριση Δεδομένων",
          url: "/settings/gdpr",
          icon: "comments-hi-dark",
          imageUrl: null
        },
        {
          key: "1490639288542",
          title: "Επεξεργασία email",
          url: "/email",
          icon: "mail-new-hi-dark",
          imageUrl: null
        }
      ]
    },
    mobile: {
      links: [
        {
          key: "1490612457852",
          title: "Ανάκτηση PUK",
          url: "/my-vodafone/puk-retrieval",
          icon: "sim-hi-dark",
          imageUrl: null
        },
        {
          key: "1490639255842",
          title: "Διαχείριση Δεδομένων",
          url: "/settings/gdpr",
          icon: "comments-hi-dark",
          imageUrl: null
        },
        {
          key: "1490674856324",
          title: "Φραγή σε SMS υψηλής χρέωσης",
          url: "/my-vodafone/barring-categories/psms",
          icon: "chat-hi-dark",
          imageUrl: null
        }
      ]
    }
  },
  eSim: {
    compatibleDevicesUrl: "/ext_files/test-pages/eSim-compatible-devices.html"
  },
  cpeManagement: {
    links: [
      {
        image: null,
        icon: null,
        title: "Επανεκκίνηση",
        url: "#chatkeyword=cpereboot",
        button: {
          text: "Συνέχισε στο chat",
          url: "#chatkeyword=cpereboot",
          importance: "button--tertiary",
          target: "_self"
        },
        imageUrl:
          "https://images.ctfassets.net/b79acpktwvj7/1Pvmd5iNvNHu910ylH2G1A/2fa85b4ffe063fc793bcdec6d0cb9966/cpe-management-reboot.jpg?fm=webp&q=93&h=600",
        text:
          "Με την βοήθεια του TOBi θα μπορέσεις να κάνεις επανεκκίνηση του Vodafone router σου απομακρυσμένα χωρίς να σηκωθείς από την καρέκλα σου.",
        key: 1490639376985
      },
      {
        image: null,
        icon: null,
        title: "Επαναφορά εργοστασιακών ρυθμίσεων",
        url: "#chatkeyword=cpereset",
        button: {
          text: "Συνέχισε στο chat",
          url: "#chatkeyword=cpereset",
          importance: "button--tertiary",
          target: "_self"
        },
        imageUrl:
          "https://images.ctfassets.net/b79acpktwvj7/38juPYE4D2wjgphTSwLvcb/bf2511744e2410588334188e700830bd/cpe-management-reset.jpg?fm=webp&q=93&h=600",
        text:
          "Με την βοήθεια του TOBi θα μπορέσεις να κάνεις επαναφορά των εργοστασιακών ρυθμίσεων του Vodafone router σου απομακρυσμένα.<br> <strong>Προσοχή!</strong> Οι υπάρχουσες ρυθμίσεις θα χαθούν.",
        key: 1490639377013
      },
      {
        image: null,
        icon: null,
        title: "Ρυθμίσεις Wi-Fi",
        url: "#chatkeyword=rythmiseiswififaqs",
        button: {
          text: "Συνέχισε στο chat",
          url: "#chatkeyword=rythmiseiswififaqs",
          importance: "button--tertiary",
          target: "_self"
        },
        imageUrl:
          "https://images.ctfassets.net/b79acpktwvj7/1uheAbG9zJri659m1mnPw3/6f17b2d54773ba91ad42c07aabf9590e/cpe-management-wifi-settings.jpg?fm=webp&q=93&h=600",
        text:
          "Με την βοήθεια του TOBi θα μπορέσεις να αλλάξεις το όνομα και τον κωδικό του Wi-Fi του Vodafone router σου εύκολα και γρήγορα.",
        key: 1490639377045
      }
    ]
  }
};

exports.data = data;
